/* Component Dependencies */
var otherTransportationTemplate = require('templates/otherTransportation.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'otherTransportation',
  template: {
    'otherTransportation': otherTransportationTemplate
  }
});
